<template>
  <div class="w-full h-full">
    <el-carousel class="carouselIcon h-full relative" :interval="data.speed * 1000" height="380px">
      <el-carousel-item v-for="(item, index) in carouselArr" :key="index" class="cursor-pointer">
        <div class="w-full h-full" @click="toDetail(item)">
          <div class="w-full h-full flex items-center justify-center">
            <el-image
              :src="`${fileUrl}${item.imageFile}`"
              :fit="data.imageFit || 'fill'"
              class="w-full h-full"
            ></el-image>
            <!-- <img :src="`${fileUrl}${item.imageFile}`" alt="" class="w-full h-full object-contain" /> -->
          </div>
          <div
            class="w-full h-45px text-18px pt-7px px-10px bg-hex-000 bg-opacity-50 text-center font-bold truncate absolute bottom-0 text-hex-fff"
            :title="item.title"
          >
            {{ item.title }}
          </div>
        </div>
      </el-carousel-item>
      <div class="absolute bottom-50 left-0 z-10 customize">
        <!-- <button>customize</button> -->
      </div>
    </el-carousel>
  </div>
</template>
<script>
import { ColumnTableApi } from '@wiz-api/workbench-std'
import addRequestQueue from '@/assets/js/RequestQueue'

const columnTableApi = new ColumnTableApi()
export default {
  name: 'carousel',
  props: {
    data: {
      type: Object,
      default: () => {
        return {}
      },
    },
    mode: {
      type: String,
      default: '',
    },
  },
  computed: {
    fileUrl() {
      const fileServer = Wiz.GetModuleServer('file-management')
      return `${fileServer}/api/file-management/files/public/image/`
    },
    routerBase() {
      if (window.__POWERED_BY_QIANKUN__) {
        return `/${_.get(Wiz, 'globalSettings.globalConfig.routerBase')}`
      }
      return ''
    },
  },
  watch: {
    data: {
      immediate: true,
      deep: true,
      handler(val) {
        if (!_.isEmpty(val) && !_.isEmpty(val.dataSource)) {
          this.getCompentsData(val.dataSource, val.pageSize)
        }
      },
    },
  },
  data() {
    return {
      carouselArr: [],
    }
  },
  methods: {
    async toDetail(row) {
      if (this.mode === 'update') {
        return
      }
      if (row.jumpType === 2) {
        row.skipMode === 1 ? window.open(row.url) : (window.location.href = row.url)
      } else if (row.jumpType === 1) {
        const path = `${this.routerBase}/integration/portal/homepage?columnId=${row.jumpColumn}`
        // row.skipMode === 1
        //   ? window.open(`${window.location.origin}${window.location.hash ? '/#' : ''}${path}`)
        //   : this.$router.push(path)
        window.open(`${window.location.origin}${window.location.hash ? '/#' : ''}${path}`)
      }
    },
    async getCompentsData(id, pageSize) {
      const param = {
        columnId: id,
        isShow: true,
      }
      const [err, res] = await addRequestQueue(() => {
        return columnTableApi.getBinnerColumnTable(1, pageSize, param)
      })
      if (!err && res) {
        this.carouselArr = []
        _.map(res.items, (it) => {
          it.isShow === true ? this.carouselArr.push(it) : ''
        })
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.carouselIcon {
  &:hover {
    .customize {
      display: block;
    }
  }
  .customize {
    display: none;
  }
  ::v-deep .el-carousel__container {
    height: 100% !important;
  }
  ::v-deep .el-carousel__button {
    height: 3px;
    width: 3px;
    border-radius: 100%;
  }
  ::v-deep .is-active {
    .el-carousel__button {
      height: 3px;
      width: 9px;
      border-radius: 3px;
      background: var(--portalPrimaryColor);
    }
  }
}
</style>
